import React from 'react';
import desktopLasers from '../../assets/img/portal-lasers-desktop.webp';
import mobileLasers from '../../assets/img/portal-lasers-mobile.webp';

/** Static captures of FRAGS.lasers at t=12, with the original scanlines and vignette.
 * Page backgrounds must not mount WebGL: the continuously drawing canvas caused
 * foreground flicker in Chrome, even behind opaque pages such as Messages.
 * Portal cards retain their separate, intentionally animated backgrounds.
 */
export const PAGE_INK_VARS = Object.freeze({ '--pr-page-ink': '#FFFFFF', '--pr-page-sub': '#C4C4C4' });
export const VIGNETTE = 'radial-gradient(ellipse 55% 50% at 50% 48%, rgba(0,0,0,.55), rgba(0,0,0,0) 75%)';

export function LasersImage() {
  return (
    <>
      <picture>
        <source media="(orientation: portrait)" srcSet={mobileLasers} />
        <img data-testid="lasers-image" src={desktopLasers} alt="" aria-hidden draggable={false}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center bottom', pointerEvents: 'none' }} />
      </picture>
      <div aria-hidden style={{ position: 'absolute', inset: 0, background: 'repeating-linear-gradient(0deg, rgba(255,255,255,.03) 0 1px, transparent 1px 3px)', pointerEvents: 'none' }} />
    </>
  );
}

export default function LasersBackground({ fixed = true }) {
  return (
    <div
      aria-hidden
      data-testid="lasers-background"
      style={{ position: fixed ? 'fixed' : 'absolute', inset: 0, zIndex: -1, overflow: 'hidden', background: '#000', pointerEvents: 'none' }}
    >
      <LasersImage />
      <div style={{ position: 'absolute', inset: 0, background: VIGNETTE, pointerEvents: 'none' }} />
    </div>
  );
}
